import { useTranslation } from '../../hooks/useTranslation'
import Money from '../../design/Money'
import Moment, { MomentHeadline, MomentIcon, MomentText } from './Moment'

/** Money coming back to the customer: the largest thing on the screen, so
 *  nobody walks off without it. Set, not counted up. */
export default function ChangeMoment({
  kind,
  amount,
  currency,
}: {
  kind: 'change' | 'cashback'
  amount: number
  currency: string
}) {
  const { t } = useTranslation()
  // Literal keys, so the translation coverage test can find them.
  const headline = kind === 'change' ? 'your-change' : 'your-cashback'
  const text = kind === 'change' ? 'collect-your-change' : 'collect-your-cashback'

  return (
    <Moment>
      <MomentIcon tone="trust">↩</MomentIcon>
      <MomentHeadline>{t(headline)}</MomentHeadline>
      <div className="mt-cfd-3 whitespace-nowrap font-volte-semibold text-cfd-hero text-primary">
        <Money amount={amount} currency={currency} lead />
      </div>
      <MomentText>{t(text)}</MomentText>
    </Moment>
  )
}
